import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonSlides, IonSlide, IonInput, IonModal, IonItem, IonContent} from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


import '../css/zInternal_css.css';


export function AddProjectModal (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let projectNameRef = useRef('');
    let projectDescriptionRef = useRef('');

    function createProject(enteredPassword)
    {        
        let formData = new FormData();
        formData.append('Tracker', '74002B_create_project');
        formData.append('user', acctID);
        formData.append('xProjectName', projectNameRef.current.value);
        formData.append('xProjectDescription', projectDescriptionRef.current.value);
        formData.append('sessionID', sessionID);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        



        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }


    function closeModalHandler() {

        props.closeModal(false);
    }

    return (

            <React.Fragment>
                {
                props.openModal == true ?
                (
                    <IonModal isOpen={ props.openModal }>
                    <IonContent className='bookedDetails_gridContent_multiple'>
                    <IonSlides pager='true' className='custom-pagination' options={{ speed: 100 }}>

                        <IonSlide>
                                <IonGrid className='gridText'>
                                    <IonRow>
                                        <IonCol>
                                            <label for='searchSupplierName'>Project Name:</label>
                                        </IonCol>
                                        <IonCol>
                                            <input type='text' ref={ projectNameRef } placeholder='Enter Project Name'></input>
                                        </IonCol>
                                    </IonRow>
                                    {/*<IonRow>
                                        <IonCol>
                                            <IonButton  onClick={() => setShowSupplierModal(true)}> Add Supplier</IonButton>
                                        </IonCol>
                                    </IonRow>*/}
                                </IonGrid>
                        </IonSlide>

                        <IonSlide>
                                <IonGrid  className='gridText'>
                                    <IonRow>
                                        <IonCol>
                                            <IonLabel>Project Description: </IonLabel>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonInput type='text' placeholder='Enter Description' ref={ projectDescriptionRef }></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonButton onClick={() => createProject()}>Create Project</IonButton>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                        </IonSlide>
                    </IonSlides>
                    
                    <IonButton className='button_closeModal_center' onClick={() => closeModalHandler(false)}>Cancel </IonButton>

                        {/*<EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>*/}                        
                        {/*<IonButton onClick={() => setShowPasswordModal(true)}> Add Expense </IonButton>*/}
                        </IonContent>
                    </IonModal>) : null
                }
            </React.Fragment>

    )
}